import { HandlerEvent } from 'post-robot';
import { saveMeta } from 'communicator/store';

/**
 * On /vcop load, visa-sdk receives an visa.src.update-vdcp-config postmessage
 * with the current THM sessionId. This is only relevant for Visa-SRCi flows
 * where the app is launched from merchant SDK, which creates its own THM
 * sessionId in /config. Otherwise, the sessionId will be the same as the one in
 * state.
 */
export default function updateConfig(event: HandlerEvent<{ sessionId: string }>) {
  saveMeta({
    sessionId: event.data.sessionId
  });
}
